(function ($) {
    if($( ".testimonials-slider" ).length) {
        $( ".testimonials-slider .swiper-slide" ).each(function( index ) {
            $(this).children('.video').children('.play-button').on('click', function () {
                const video = $(this).siblings('video').get(0);
                video.play();
                $(this).addClass('hide');
                $(this).siblings('.pause-button').addClass('active');
            });
            $(this).children('.video').children('.pause-button').on('click', function () {
                const video = $(this).siblings('video').get(0);
                video.pause();
                $(this).removeClass('active');
                $(this).siblings('.play-button').removeClass('hide');
            });
            $(this).children('.video').children('video').on('click', function () {
                let video = $(this).get(0);
                if (video.paused) {
                    $(this).get(0).play();
                    $(this).siblings('.play-button').addClass('hide');
                    $(this).siblings('.pause-button').addClass('active');
                } else {
                    $(this).get(0).pause();
                    $(this).siblings('.pause-button').removeClass('active');
                    $(this).siblings('.play-button').removeClass('hide');
                }
            });
            $(this).children('.video').children('video').on("ended", function () {
                $(this).siblings('.play-button').removeClass('hide');
                $(this).siblings('.pause-button').removeClass('active');
            });
        })
        $('body').on('click', '.play-button', function () {
            const video = $(this).siblings('video').get(0);
            video.play();
            $(this).addClass('hide');
            $('.pause-button').addClass('active');
        });
        $('.full-width-video .play-button').on('click', function () {
            const video = $(this).siblings('video').get(0);
            video.play();
            $(this).addClass('hide');
            $('.pause-button').addClass('active');
        });
        $('.pause-button').on('click', function () {
            const video = $(this).siblings('video').get(0);
            video.pause();
            $(this).removeClass('active');
            $('.play-button').removeClass('hide');
        });
        $('video').on('click', function () {
            let video = $(this).get(0);
            if (video.paused) {
                $(this).get(0).play();
                $(this).siblings('.play-button').addClass('hide');
                $(this).siblings('.pause-button').addClass('active');
            } else {
                $(this).get(0).pause();
                $(this).siblings('.pause-button').removeClass('active');
                $(this).siblings('.play-button').removeClass('hide');
            }
        });
        $('video').on("ended", function () {
            $('.play-button').removeClass('hide');
            $('.pause-button').removeClass('active');
        });
    }else {
        $('body').on('click', '.play-button', function () {
            const video = $(this).siblings('video').get(0);
            video.play();
            $(this).addClass('hide');
            $(this).siblings('.pause-button').addClass('active');
        });
        $('.full-width-video .play-button').on('click', function () {
            const video = $(this).siblings('video').get(0);
            video.play();
            $(this).addClass('hide');
            $(this).siblings('.pause-button').addClass('active');
        });
        $('.pause-button').on('click', function () {
            const video = $(this).siblings('video').get(0);
            video.pause();
            $(this).removeClass('active');
            $('.play-button').removeClass('hide');
        });
        $('video').on('click', function () {

            let video = $(this).get(0);
            if (video.paused) {
                $(this).get(0).play();
                $(this).siblings('.play-button').addClass('hide');
                $(this).siblings('.pause-button').addClass('active');
            } else {
                $(this).get(0).pause();
                $(this).siblings('.pause-button').removeClass('active');
                $(this).siblings('.play-button').removeClass('hide');
            }
        });
        $('video').on("ended", function () {
            $('.play-button').removeClass('hide');
            $('.pause-button').removeClass('active');
        });

    }
    let video = $('.video');
    let newCurrentTime = 0;
    video.each( function(index,el) {
       let vid = $(this).find('#video');
        let volumeControl = $(this).find('#vol-control');
        volumeControl.on('change', function() {
            vid.prop("volume",this.value /100)
        });

        $(el).find('.js-range-slider').ionRangeSlider({
            onStart: function (data) {

            },
            onChange: function (data) {
                newCurrentTime = $(el).find("#video")[0].duration * parseInt( data.from_percent)/ 100 ;//38*0.3
                $(el).find("#video")[0].currentTime = newCurrentTime;
            },
        })
        function handleProgress(e,a,b) {
            var target = e.target;
            let newCurrentTime = 0;
            if(e.type === "timeupdate"){
                newCurrentTime = e.target.currentTime;
                // Update the slider position
                var rangeSliderWidth = $(".range-slider-progress-bar").width() - $(".irs-handle.single").width();
                var audioPercent = e.target.currentTime / e.target.duration;
                var sliderPos = rangeSliderWidth*audioPercent;
                a.css({"left":sliderPos});
                b.css({"width":sliderPos});

            }
        }
        vid.on('timeupdate',  function(e, a,b){  // on currentTime change
            var handle = $(this).siblings('.controls').find(".irs-handle.single");
            var bar = $(this).siblings('.controls').find(".irs-bar.irs-bar--single");
            handleProgress(e,handle,bar)
        });

    })
})(jQuery);
const rangeInputs = document.querySelectorAll('input[type="range"]')


function handleInputChange(e) {
    let target = e.target
    if (e.target.type !== 'range') {
        target = document.getElementById('range')
    }
    const min = target.min
    const max = target.max
    const val = target.value

    target.style.backgroundSize = (val - min) * 100 / (max - min) + '% 100%'
}
rangeInputs.forEach(input => {
    input.addEventListener('input', handleInputChange)
})

//media and content block
const progress = document.querySelector(".progress");

(function ($) {
    if($( "#player_media_content" ).length ) {
        const player2 = new Plyr('#player_media_content', {
            controls: ['progress'],
            clickToPlay: true,
            youtube: {noCookie: false, rel: 1, showinfo: 0, iv_load_policy: 3, modestbranding: 0},
        });
        $('.media-content-block .plyr').siblings('.play-button-yt').on('click', function () {
            player2.play();
            $(this).addClass('hide');
            $(this).siblings('.pause-button-yt').addClass('active');
            $(this).siblings('.fullscreen-button-yt').addClass('active');
        });
        $('.media-content-block .plyr').siblings('.pause-button-yt').on('click', function () {
            player2.pause();
            $(this).removeClass('hide');
            $(this).siblings('.play-button-yt').removeClass('hide');
        });
        $('.media-content-block .plyr').on("pause", function () {
            $(this).siblings('.play-button-yt').removeClass('hide');
            $(this).siblings('.pause-button-yt').removeClass('active');
            $(this).siblings('.fullscreen-button-yt').removeClass('active');
        });

        $('.media-content-block .plyr').on("play", function () {
            $(this).siblings('.play-button-yt').addClass('hide');
            $(this).siblings('.pause-button-yt').addClass('active');
            $(this).siblings('.fullscreen-button-yt').addClass('active');
        });
    }

})(jQuery);
//
(function ($) {
    if($( "#player_blog_list" ).length ) {
        const player_blog_list = new Plyr('#player_blog_list', {
            controls: [],
            // host: 'https://www.youtube.com',
            youtube: {noCookie: false, rel: 1, showinfo: 1, iv_load_policy: 3, modestbranding: 0},
            clickToPlay: true
        });

        $('.blog-list-hero .plyr').siblings('.play-button-yt').on('click', function () {
            player_blog_list.play();
            $(this).addClass('hide');
            $(this).siblings('.pause-button-yt').addClass('active');
            $(this).siblings('.fullscreen-button-yt').addClass('active');
        });
        $('.blog-list-hero .plyr').siblings('.pause-button-yt').on('click', function () {
            player_blog_list.pause();
            $(this).removeClass('hide');
            $(this).siblings('.play-button-yt').removeClass('hide');
        });
        $('.blog-list-hero .plyr').on("pause", function () {
            $(this).siblings('.play-button-yt').removeClass('hide');
            $(this).siblings('.pause-button-yt').removeClass('active');
            $(this).siblings('.fullscreen-button-yt').removeClass('active');
        });

        $('.blog-list-hero .plyr').on("play", function () {
            $(this).siblings('.play-button-yt').addClass('hide');
            $(this).siblings('.pause-button-yt').addClass('active');
            $(this).siblings('.fullscreen-button-yt').addClass('active');
        });
        $('.blog-list-hero .plyr').siblings('.fullscreen-button-yt').on('click', function () {
            player_blog_list.fullscreen.enter();
        });
    }

})(jQuery);

//testimonials slider block
(function ($) {

$(window).on('load', function() {
    $('.testimonials-slider').each((index, el) => {
        let testimonialsLoaded = false;

        if ($(window).scrollTop() + $(window).outerHeight() > $(el).offset().top && !testimonialsLoaded) {
            $(el).find('.swiper-slide').each(function( index ) {
                const player3 = new Plyr($(this).find('[id^=player_testimonials]'), {
                    controls: ['progress'],
                    clickToPlay : true,
                    // host: 'https://www.youtube.com',
                    youtube: { noCookie: false, rel: 0, showinfo: 0, iv_load_policy: 3, modestbranding: 1 },
                });

                $(this).children('.video').children('.plyr').on("pause", function() {
                    $(this).siblings('.play-button-yt').removeClass('hide');
                    $(this).siblings('.pause-button-yt').removeClass('active');
                    $(this).siblings('.fullscreen-button-yt').removeClass('active');
                });


                $(this).children('.video').children('.plyr').on("play", function() {
                    $(this).siblings('.play-button-yt').addClass('hide');
                    $(this).siblings('.pause-button-yt').addClass('active');
                    $(this).siblings('.fullscreen-button-yt').addClass('active');
                });

                $(this).children('.video').children('.play-button-yt').on('click', function() {
                    if (player3.ready) {
                        $(this).addClass('hide');
                        $(this).siblings('.pause-button-yt').addClass('active');
                        $(this).siblings('.fullscreen-button-yt').addClass('active');
                        player3.play();
                    }
                });

                $(this).children('.video').children('.pause-button-yt').on('click', function() {
                    player3.pause();
                });
                $(this).children('.video').children('.fullscreen-button-yt').on('click', function() {
                    player3.fullscreen.enter();
                });
            });
            testimonialsLoaded = true;
        }

        $(window).on('scroll', function() {
            if ($(window).scrollTop() + $(window).outerHeight() > $(el).offset().top && !testimonialsLoaded) {
                $(el).find('.swiper-slide').each(function( index ) {
                    const player3 = new Plyr($(this).find('[id^=player_testimonials]'), {
                        controls: ['progress'],
                        clickToPlay : true,
                        // host: 'https://www.youtube.com',
                        youtube: { noCookie: false, rel: 0, showinfo: 0, iv_load_policy: 3, modestbranding: 1 },
                    });

                    $(this).children('.video').children('.plyr').on("pause", function() {
                        $(this).siblings('.play-button-yt').removeClass('hide');
                        $(this).siblings('.pause-button-yt').removeClass('active');
                        $(this).siblings('.fullscreen-button-yt').removeClass('active');
                    });


                    $(this).children('.video').children('.plyr').on("play", function() {
                        $(this).siblings('.play-button-yt').addClass('hide');
                        $(this).siblings('.pause-button-yt').addClass('active');
                        $(this).siblings('.fullscreen-button-yt').addClass('active');
                    });


                    $(this).children('.video').children('.play-button-yt').on('click', function() {
                        if (player3.ready) {
                            $(this).addClass('hide');
                            $(this).siblings('.pause-button-yt').addClass('active');
                            $(this).siblings('.fullscreen-button-yt').addClass('active');
                            player3.play();
                        }
                    });

                    $(this).children('.video').children('.pause-button-yt').on('click', function() {
                        player3.pause();
                    });
                    $(this).children('.video').children('.fullscreen-button-yt').on('click', function() {
                        player3.fullscreen.enter();
                    });
                });
                testimonialsLoaded = true;
            }
        });
    })
})

})(jQuery);

//media block
(function ($) {
    if($( "#player" ).length) {
        const player = new Plyr('#player', {
            controls: ['progress'],
            // // host: 'https://www.youtube.com',
            youtube: { noCookie: false, rel: 0, showinfo: 0, iv_load_policy: 3, modestbranding: 1 },
            clickToPlay: true
        });

        $('.media-block .plyr').on("pause", function() {
            $(this).siblings('.play-button-yt').removeClass('hide');
            $(this).siblings('.pause-button-yt').removeClass('active');
            $(this).siblings('.fullscreen-button-yt').removeClass('active');
        });

        $('.media-block .plyr').on("play", function() {
            $(this).siblings('.play-button-yt').addClass('hide');
            $(this).siblings('.pause-button-yt').addClass('active');
            $(this).siblings('.fullscreen-button-yt').addClass('active');

        });
        $('.media-block .plyr').siblings('.play-button-yt').on('click', function() {
            player.play();
            $(this).addClass('hide');
            $(this).siblings('.pause-button-yt').addClass('active');
            $(this).siblings('.fullscreen-button-yt').addClass('active');
        });

        $('.media-block .plyr').siblings('.pause-button-yt').on('click', function() {
            player.pause();
            $(this).siblings('.play-button-yt').removeClass('hide');
            $(this).siblings('.pause-button-yt').removeClass('active');
            $(this).siblings('.fullscreen-button-yt').removeClass('active');
        });

        $('.media-block .plyr').siblings('.fullscreen-button-yt').on('click', function() {
            player.fullscreen.enter();
        });

    }
})(jQuery);







